import {  useState } from "react";
import StarChartsOrgActionContainer from "../starChartsOrg.action.container/StarChartsOrgActionContainer";
import StarChartsOrgListContainer from "../starChartOrg.list.container/starChartOrgListContainer";
import { useNavigate } from "react-router-dom";
import StarChartOrgItemDeleteContainer from "../starChartOrg.item.delete.container/StarChartOrgItemDeleteContainer";



const StarChartOrgMainContainer = () => {

  const [sort, setSort] = useState<string>('-createdAt')
  const [page, setPage] = useState<number>(1)
  const [limit, setLimit] = useState<number>(25)
  const [starChartName, setStarChartName] = useState<string>('')
  const [term, setTerm] = useState<string>('')
  const [starChartDelete, setStarChartDelete] = useState<boolean>(false)
  const [clonePopup, setClonePopup] = useState<boolean>(false)


   const navigation = useNavigate()


  const starChartsList = {
    "ids": [
        "67cdf665b64ccf1b9a42d1b3",
        "67571f75df56000e13cff73a",
        "672f7fa9a19125f0ba72f12e",
        "672f6aa5a19125f0ba72eb3b",
        "6703c0c385756f0527400da3",
        "66f80c326fb9d828148bcb71",
        "66d875392e611c0d683c8eb9",
        "66cf3279fe0459c5bedc97eb",
        "66cf3144fe0459c5bedc97b3",

    ],
    "entities": {
        "67cdf665b64ccf1b9a42d1b3": {
            "_id": "67cdf665b64ccf1b9a42d1b3",
            "image": "https://api.gradegy.com/static/download.ff.png",
            "name": "ORGstar",
            "status": true,
            "experienceCount": 30,
        },
        "67571f75df56000e13cff73a": {
            "_id": "67571f75df56000e13cff73a",
            "image": "https://api.gradegy.com/static/download.ff.png",
            "name": "star",
            "status": false,
            "experienceCount": 30,
        },
        "672f7fa9a19125f0ba72f12e": {
            "_id": "672f7fa9a19125f0ba72f12e",
            "image": "https://api.gradegy.com/static/download.ff.png",
            "name": "star",
            "status": true,
            "experienceCount": 30,
        },
        "672f6aa5a19125f0ba72eb3b": {
            "_id": "672f6aa5a19125f0ba72eb3b",
            "image": "https://api.gradegy.com/static/download.ff.png",
            "name": "star",
            "status": false,
            "experienceCount": 30,
        },
        "6703c0c385756f0527400da3": {
            "_id": "6703c0c385756f0527400da3",
            "image": "",
            "name": "star",
            "status": false,
            "experienceCount": 30,
        },
        "66f80c326fb9d828148bcb71": {
            "_id": "66f80c326fb9d828148bcb71",
            "image": "https://api.gradegy.com/static/download.ff.png",
            "name": "star",
            "status": false,
            "experienceCount": 30,
        },
        "66d875392e611c0d683c8eb9": {
            "_id": "66d875392e611c0d683c8eb9",
            "image": "https://api.gradegy.com/static/file-1725461796214-269692626.webp",
            "name": "star",
            "status": false,
            "experienceCount": 30,
        },
        "66cf3279fe0459c5bedc97eb": {
            "_id": "66cf3279fe0459c5bedc97eb",
            "image": "https://api.gradegy.com/static/download.ff.png",
            "name": "star",
            "status": false,
            "experienceCount": 30,
        },
        "66cf3144fe0459c5bedc97b3": {
            "_id": "66cf3144fe0459c5bedc97b3",
            "image": "",
            "status": false,
            "name": "star2",
            "experienceCount": 30,
        },

        
    }
}


  const openHandler = () => {
    navigation('/createStarChartOrg')
  }

  const onStarChartDelete = (name: string) => {
    setStarChartDelete(true);
    setStarChartName(name);
  }

  const closeDeletePopup = () => {
    setStarChartDelete(false)
  }

  const onClonePopup = () => {
    setClonePopup(!clonePopup)
  }


  




  const onSort = (fieldName: string) => {
    if (sort === 'null') {
      setSort(`-${fieldName}`)
    }
    if (sort.startsWith('-')) {
      setSort(fieldName)
    }
    if (!sort.startsWith('-')) {
      setSort(`-${fieldName}`)
    }
  }

  return (
    <>
     
      <StarChartsOrgActionContainer
        openStarChartsAddHandler={openHandler}
        term={term}
        setTerm={setTerm}
        clonePopup={clonePopup}
        onClonePopup={onClonePopup}
      />

      {starChartsList && (
        <>
            <StarChartsOrgListContainer
              starChartsList={starChartsList}
              page={page}
              limit={limit}
              setLimit={setLimit}
              setPage={setPage}
              sort={sort}
              onSort={onSort}
              onStarChartDelete={onStarChartDelete}
         
            />

            <StarChartOrgItemDeleteContainer starChartDelete={starChartDelete} closeDeletePopup={closeDeletePopup} starChartName={starChartName}/>

        </>


        
      )}
    </>
  )
}

export default StarChartOrgMainContainer
